import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * 统一返回行为:优先浏览器 history 弹栈(navigate(-1)),
 * 仅当无可弹历史(深链/直接打开,idx===0)时 replace 到 fallback。
 * 弹栈永不 push、fallback 用 replace → 从根上杜绝「返回死循环」。
 *
 * idx 由 react-router v7(history v5)维护在 window.history.state.idx,
 * 记录当前条目在会话历史中的序号。
 */
export function useGoBack(fallback = '/forum') {
  const navigate = useNavigate()
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) void navigate(-1)
    else void navigate(fallback, { replace: true })
  }, [navigate, fallback])
}
